/** 全局 store */
import React from 'react';
// 引入action
import { storeUserInfo, storeQuantileTimeList } from '../../store/action.js'
import { connect } from 'react-redux'
// import pub from "../../lib/public";

class GlobalStore extends React.Component{
  UNSAFE_componentWillMount() {
    // console.log(window.location.search, window.location.href.split('SID=')[1])
    // cookie 不存在 并且路由上有 SID时调用
    // if (window.location.href && window.location.href.includes('SID')) {
    //   const SID = window.location.href.split('SID=')[1];
    //   pub.setCookie("SID", SID);
    // }
    // store
    const {dispatch} = this.props;
    dispatch(storeUserInfo());
    dispatch(storeQuantileTimeList());
  };
  render() {
    return '';
  }
};
export default connect()(GlobalStore);
